import Api from '@/api/Api'
import qs from 'qs'
import store from '../store'

export default {

  async register (data) {
    return Api().post('user/register', data)
  },

  async login (data) {
    let json = {
      email: data.email,
      password: data.password,
    }
    return store.dispatch('checkResponseApi', await Api().post('user/login', qs.stringify(json)))
  },

  async loginShop (data) {
    let json = {
      shop_id: data.shop_id,
    }
    return store.dispatch('checkResponseApi', await Api().post('user/login/shop', qs.stringify(json)))
  },

  async getMe () {
    return store.dispatch('checkResponseApi', await Api().get('user/me'))
  },

  async checkCandidate (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('check/candidate', data, options))
  },

  async resetPassword (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('user/reset/password', data, options))
  },
}



// WEBPACK FOOTER //
// ./src/api/AuthService.js